import { render } from "./App.vue?vue&type=template&id=79d5b5f1"
const script = {}

import "./App.vue?vue&type=style&index=0&id=79d5b5f1&lang=css"
script.render = render

export default script